const state = {
  alert: {
    msg: '',
    status: true,
    show: false
  },
  adicionarEvidencia: {
    conteudo: '',
    show: false
  },
  adicionarGlosa: {
    conteudo: '',
    show: false
  },
  extraContratual: {
    conteudo: '',
    show: false
  },
  modalListaGlosasPorMes: {
    conteudo: [],
    show: false
  },
  adicionarExtraContratual: {
    conteudo: '',
    show: false
  },
  modalConfirmarMultaGlosa: {
    conteudo: '',
    show: false
  },
  dadosFornecedor: {
    fornecedor: ''
  },
  planilhasChamados: {
    show: false
  },
  planilhaSLA: {
    show: false
  },
  planilhasPreventivas: {
    show: false
  },
  fechamentoFixoVariavel: {
    show: false
  },
  exportarExtra: {
    show: false
  }
}

const mutations = {
  setAlert(state, obj) {
    state.alert = obj
  },
  setDadosFornecedor(state, obj) {
    state.dadosFornecedor = obj
  },
  setAdicionarEvidencia(state, obj) {
    state.adicionarEvidencia = obj
  },
  setAdicionarGlosa(state, obj) {
    state.adicionarGlosa = obj
  },
  setExtraContratual(state, obj) {
    state.extraContratual = obj
  },
  setModalListaGlosasPorMes(state, obj) {
    state.modalListaGlosasPorMes = obj
  },
  setModalConfirmarMultaGlosa(state, obj) {
    state.modalConfirmarMultaGlosa = obj
  },
  setPlanilhasChamados(state, obj) {
    state.planilhasChamados = obj
  },
  setPlanilhaSLA(state, obj) {
    state.planilhaSLA = obj
  },
  setPlanilhasPreventivas(state, obj) {
    state.planilhasPreventivas = obj
  },
  setModalFechamentoFixoVariavel(state, obj) {
    state.fechamentoFixoVariavel = obj
  },
  setModalExportarExtra(state, obj) {
    state.exportarExtra = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/modal.js